import { render, staticRenderFns } from "./OrganizationsDetail.vue?vue&type=template&id=2ed6278c"
import script from "./OrganizationsDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports